import { AdminApi } from 'stylemix-vue-admin'

export default class DeferredPaymentsApi extends AdminApi {
  constructor(parameters) {
    super('deferred-payments', parameters)
  }

  totals(config = {}) {
    return this.submit('get', `/${this.endpoint}/totals`, {}, config)
  }

  process(ids, config = {}) {
    return this.submit('post', `/${this.endpoint}/process`, { ids }, config)
  }
}
